<template>

    <footer class="footer">

        <div class="container" v-show="stepReached > 1 || step > 1 || acceptStatus === 'Submitted' ">
            <div class="columns level-footer-buttons is-mobile" v-if="acceptStatusValid">
                <div class="column column--left has-text-centered" v-bind:class="{'_footer-hover': step > 1}"
                     @click="prevStep()">
                    <button type="button" v-bind:class="{'btn-primary': !reopenVisible, 'btn-tertiary': reopenVisible}"
                            v-show="step > 1"><span class="fa fa-arrow-left has-text-orange"></span>&nbsp;&nbsp;BACK
                    </button>
                </div>
                <div class="column is-hidden-mobile">
                    &nbsp;
                </div>

                <div class="column column--right has-text-centered" @click="nextStep()">
                    <button type="button" v-bind:class="{'btn-primary': !reopenVisible, 'btn-tertiary': reopenVisible}"
                            _v-if="step != 3" v-show="step < 3">NEXT&nbsp;&nbsp;<span
                            class="fa fa-arrow-right has-text-orange"></span></button>
                    <!--<span class="form-step">Step 4 - Send us your quote when you're done!</span><br>-->
                    <button type="submit" v-show="!reopenVisible && step === 3"
                            v-bind:class="{'btn-primary': !reopenVisible, 'btn-tertiary': reopenVisible, 'is-danger': submittedSuccess === false}"
                            v-bind:disabled="submitting || submittedSuccess">
                        <span v-show="!hideTextForMobileLoader && submittedSuccess === true"><i
                                class="fas fa-check"></i>&nbsp;&nbsp;</span>
                        <span v-show="!hideTextForMobileLoader && submittedSuccess === false"><i
                                class="fas fa-exclamation-triangle"></i>&nbsp;&nbsp; ERROR SUBMITTING</span>
                        <span v-show="!hideTextForMobileLoader && submittedSuccess !== false"> SUBMIT<span
                                v-show="!hideTextForMobileLoader && submittedSuccess === true && !submitting">TED</span><span
                                v-show="!hideTextForMobileLoader && submitting === true">TING</span>&nbsp;QUOTE</span>
                        <button type="button" v-show="submitting"
                                class="button is-loading white-loader"
                                v-bind:class="{'btn-loader': !hideTextForMobileLoader}"
                        ></button>
                    </button>
                </div>
            </div>
        </div>

        <section-totals v-show="stepReached > 1 || step > 1 || acceptStatus === 'Submitted' "
                        :quote-request="quoteRequest"
                        :item-sub-total="itemSubTotal"
                        :item-tax-total="itemTaxTotal"
                        :item-total="itemTotal"
                        :date-submitted="formattedDateSubmitted"
                        v-on:updateTaxChk="updateTaxCheckbox"
                        v-on:commitItemAmount="commitItemAmount"
                        :step="step"
                        :step-reached="stepReached"
        >
        </section-totals>

        <div class="level is-mobile">
            <div v-if="!hideLogo" class="level-left">
                <div class="level-item"><a href="https://buildxact.com/"
                                           title="Open Buildxact in a new window or tab" target="_blank"><img
                        class="level-item footer-logo" :src="logo"></a></div>
            </div>
            <div v-if="!hideLogo" class="level-right  has-text-right level-right--short-mbl">
                <div class="level-item">Powered by&nbsp;<a href="https://buildxact.com/"
                                                           title="Open Buildxact in a new window or tab"
                                                           target="_blank"><strong>Buildxact</strong></a><span
                        class="is-hidden-mobile">&nbsp;-&nbsp;easy online estimating and job management</span>.
                    Copyright &copy; {{dateYear}}
                </div>
            </div>
            <div v-else class="level-item">Powered by&nbsp;<a href="https://buildxact.com/"
                                                              title="Open Buildxact in a new window or tab"
                                                              target="_blank"><strong>Buildxact</strong></a><span
                    class="is-hidden-mobile">&nbsp;-&nbsp;easy online estimating and job management</span>. Copyright
                &copy; {{dateYear}}
            </div>
        </div>
    </footer>

</template>

<script>
import moment from 'moment'

import SectionTotals from '@/components/pages/sections/SectionTotals.vue'

import logo from '@/assets/logo_150px_grey.png'

export default {
  name: 'footer-nav',
  components: {SectionTotals},
  props: ['token', 'quoteRequest', 'hideLogo', 'submitting', 'submittedSuccess', 'step', 'stepReached', 'itemSubTotal', 'itemTaxTotal', 'itemTotal', 'formattedDateSubmitted'],
  mounted () {

  },
  data () {
    return {
      logo,
      totalSteps: 3
    }
  },
  methods: {
    prevStep () {
      let currentStep = this.$store.state.data.recipient.step
      let nextStep = Math.max(1, currentStep - 1)
      this.$store.commit('updateStep', nextStep)
      this.$emit('stepChanged')
    },
    nextStep () {
      if (this.step === 3) {
        // Submit
      } else {
        // Normal next button action
        let currentStep = this.$store.state.data.recipient.step
        let nextStep = Math.min(this.totalSteps, currentStep + 1)
        this.$store.commit('updateStep', nextStep)
        let currentMaxStepReached = this.$store.state.data.recipient.stepReached
        this.$store.commit('updateStepReached', Math.max(currentMaxStepReached, nextStep))
        this.$emit('stepChanged')
      }
    },
    updateTaxCheckbox (value) {
      this.$emit('updateTaxCheckbox', value)
    },
    commitItemAmount () {
      this.$emit('commitItemAmount')
    }
  },
  computed: {
    dateYear () {
      return moment().format('YYYY')
    },
    acceptStatus () {
      if (this.$store.state.data && this.$store.state.data.recipient) {
        return this.$store.state.data.recipient.quoteStatus
      } else {
        return 'Notified'
      }
    },
    acceptStatusValid () {
      // Don't include Opened
      // this.$store.state.data.recipient.quoteStatus === 'Opened'
      return ((this.$store.state.data && this.$store.state.data.recipient && (this.$store.state.data.recipient.quoteStatus === 'Quoting' || this.$store.state.data.recipient.quoteStatus === 'Submitted')) || this.stepReached > 1)
    },
    isMobile () {
      return window.innerWidth <= 768
    },
    hideTextForMobileLoader () {
      return this.isMobile && this.submitting
    },
    reopenVisible () {
      return this.$store.state.reopenVisible
    }
  }
}
</script>
